export const ACTION_PREFIXES = ['>', '@', '#', ':', '?'] as const

export type ActionPrefix = (typeof ACTION_PREFIXES)[number]
